
const linkColumns = document.querySelectorAll('.linkcolumn');
const linkColumnFiles = document.querySelectorAll('.linkcolumn-file');
const selectElements = document.querySelectorAll('select');

selectElements.forEach((selectElement) => {
  const selectColumn = selectElement.getAttribute('data-origin-column');
  const selectAnchor = selectElement.getAttribute('data-origin-anchor');
  const matchingLinkColumn = document.querySelector(`.linkcolumn[data-column="${selectColumn}"] .linkcolumn-anchor[data-anchor="${selectAnchor}"]`);

  if (matchingLinkColumn) {
    matchingLinkColumn.appendChild(selectElement);

    selectElement.addEventListener('change', (event) => {
        const selectedOption = event.target.selectedOptions[0];
        if (selectedOption) {
          const fileLink = selectedOption.dataset.fileLink;
          if (fileLink) {
            window.location.href = fileLink;
          } else {
            console.log("fileLink is empty");
          }
        }
      });
    } else {
      selectElement.classList.add('hide');
    }
});

linkColumns.forEach((linkColumn) => {
  const linkColumnAttr = linkColumn.getAttribute('data-column');
  const linkColumnAnchor = linkColumn.querySelector('.linkcolumn-anchor');
  const linkColumnAnchorAttr = linkColumnAnchor ? linkColumnAnchor.getAttribute('data-anchor') : null;
  const selectElements = document.querySelectorAll(`select[data-origin-column="${linkColumnAttr}"][data-origin-anchor="${linkColumnAnchorAttr}"]`);

  linkColumn.querySelectorAll('.linkcolumn-link').forEach((linkColumnLink) => {
    const linkColumnLinkAttr = linkColumnLink.getAttribute('data-linkcolumn-link');

    if (linkColumnLinkAttr === linkColumnAttr) {
      const clonedDiv = linkColumnLink.cloneNode(true);
      clonedDiv.textContent = linkColumnLink.textContent;
      linkColumn.appendChild(clonedDiv);
      linkColumnLink.classList.add('hide');

      linkColumnFiles.forEach((linkColumnFile) => {
        const linkColumnFileAttr = linkColumnFile.getAttribute('data-linkcolumn-file');
        if (linkColumnFileAttr === linkColumnAttr) {
          linkColumn.appendChild(linkColumnFile);
        }
      });
    }
  });
});

const linkColumnAnchors = document.querySelectorAll('.linkcolumn-anchor');

linkColumnAnchors.forEach(anchor => {
  const selects = anchor.querySelectorAll('select');

  if (selects.length > 1) {
    const newSelect = document.createElement('select');
    newSelect.classList.add('visually-hidden');
    selects.forEach(select => {
      const options = select.querySelectorAll('option');
      options.forEach(option => {
        newSelect.appendChild(option.cloneNode(true));
      });
      
      select.remove();
    });
    
    anchor.appendChild(newSelect);
    
    newSelect.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
      if (selectedOption) {
          const fileLink = selectedOption.dataset.fileLink;
          if (fileLink) {
            window.location.href = fileLink;
          } else {
            console.log("fileLink is empty");
          }
        }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  let linkColumns = document.querySelectorAll('.linkcolumn');
  linkColumns.forEach(function(linkColumn) {
    let selectElements = linkColumn.querySelectorAll('select');
    selectElements.forEach(function(selectElement) {
      let alreadyAddedPleaseSelectOption = false;
      let options = selectElement.querySelectorAll('option');
      let newOptions = [];
      options.forEach(function(option) {
        if (option.value === "" && alreadyAddedPleaseSelectOption) {
          return;
        }
        if (option.value === "") {
          alreadyAddedPleaseSelectOption = true;
        }
        newOptions.push(option);
      });
      selectElement.innerHTML = "";
      newOptions.forEach(function(option) {
        selectElement.appendChild(option);
      });
    });
  });
});

const anchors = document.querySelectorAll('.anchor');

anchors.forEach(anchor => {
  anchor.addEventListener('click', () => {
    const select = anchor.nextElementSibling;
    select.classList.toggle('visually-hidden');
  });
});

